import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '../node_modules/plyr/dist/plyr.css';
import './styles/global.scss';

ReactDOM.render(<App />, document.getElementById('root'));
